import ko from "lib/knockout";
import _ from "lib/underscore";
import {BaseList} from "./lists";
import {Settings} from "./settings";
import * as urlUtils from "../../../../core/utils/url";
import {debugInfo, settings} from "../data";

export class ProductList extends BaseList {
	_favorites = ko.observable([]);

	/**
	 * @param {Settings} settings
	 */
	constructor(settings) {
		super({name: 'products', settings});

		this._favoritesHash = ko.pureComputed(() => {
			const hash = {};
			this._favorites().forEach(id => hash[id] = true);
			return hash;
		});
	}

	initData(data) {
		if (_.isArray(data['favorites'])) {
			this._favorites(data['favorites']);

			if (_.isArray(data['items']) && this._favorites().length > 0) {
				// inject "favorite" flag
				const favoritesHash = this._favoritesHash();
				const newItems = _.map(data['items'], item => ({
					...item,
					favorite: favoritesHash[item.id]
				}));
				data = {
					...data,
					items: newItems
				};
			}
		}
		if (settings.debug && _.isObject(data['scores']) && _.isArray(data['items'])) {
			const newItems = _.map(data['items'], item => ({
				...item,
				score: data['scores'][item['id']]
			}));
			data = {
				...data,
				items: newItems
			};
		}
		super.initData(data);
	}

	newItem(itemData) {
		return new ProductItem(itemData, this.settings);
	}
}

export class ProductItem {
	/**
	 * @param {object} data
	 * @param {Settings} settings
	 */
	constructor(data, settings) {
		this.id = data.id;
		this.title = data.title;
		this.url = settings.getProductUrl(data.uri);
		this.images = _.map(data.images, img => settings.getImageUrl(img));
		this.previews = _.map(data.previews, img => settings.getPreviewImgageUrl(img));
		this.previewImage = _.first(this.previews);
		this.orderUrl = urlUtils.siteUrl('create_order?productId=' + this.id);
		this.updateDate = new Date(data['updateTime']);
		this.offersCount = data.offersCount;
		this.bestOffer = new Offer(data.bestOffer);
		this.price = settings.convertPrice(data.price);
		this.priceOld = settings.convertPrice(data.oldPrice);
		this.discount = data.discount;
		this.score = data.score;

		if (settings.useOfferUrl) {
			this.url = this.bestOffer.url;
		}

		this._favorite = ko.observable(!!data.favorite);
	}

	get isFavorite() {
		return this._favorite();
	}

	get hasImages() {
		return this.images.length > 0;
	}

	showImages() {
		if (this.hasImages) {
			$.fancybox.open(_.map(this.images, img => ({
				type: 'image',
				src: img
			})));
		}
	}

	showDebugInfo() {
		if (settings.debug && this.score) {
			debugInfo.show('product', this.id);
		}
	}
}

export class Offer {
	constructor(data) {
		this.id = data.id;
		this.name = data.name;
		this.price = settings.convertPrice(data.price);
		this.oldPrice = settings.convertPrice(data.oldPrice);
		this.discount = data.discount;
		this.shop = new Shop(data.shop);
		this.url = settings.getOfferUrl(data.id);
	}
}

export class Shop {
	constructor(data) {
		this.id = data.id;
		this.title = data.title;
		this.url = settings.getShopUrl(data.shopSlug);
	}
}



// WEBPACK FOOTER //
// ./modules/shop/common/model/products.js